export default __webpack_public_path__ + "444cabb38b02e5135ec04329f97f7676.png";